import Vue from 'vue'
import VueRouter from 'vue-router'
import test from '../views/test.vue'
import Login from '../views/login.vue'
import register from '../views/register/register.vue'
import forgetPassword from '../views/forgetPassword/forgetPassword.vue'
import reset from '../views/reset/reset.vue'
import state from '../views/state/state.vue'
import dataRequest from '../views/dataRequest.vue'
import datafilling from '../views/datafilling/datafilling.vue'
import appstatusquery from '../views/appstatusquery.vue'
import selectidentity from '../views/selectidentity.vue'
import SearchDataByStudent from '../views/searchDataByStudent.vue'
import freshgraduate from '../views/freshgraduate/freshgraduate.vue'
import formerstudents from '../views/formerstudents/formerstudents.vue'




Vue.use(VueRouter)

const routes = [{
    path: '/test',
    name: 'test',
    component: test
}, {
    path: '/',
    name: 'Login',
    component: Login
}, {
    path: '/register',
    name: 'register',
    component: register
}, {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: forgetPassword
}, {
    path: '/reset',
    name: 'reset',
    component: reset
}, {
    path: '/state',
    name: 'state',
    component: state
}, {
    path: '/dataRequest',
    name: 'dataRequest',
    component: dataRequest
}, {
    path: '/datafilling',
    name: 'datafilling',
    component: datafilling
}, {
    path: '/appstatusquery',
    name: 'appstatusquery',
    component: appstatusquery
}, {
    path: '/selectidentity',
    name: 'selectidentity',
    component: selectidentity
}, {
    path: '/freshgraduate',
    name: 'freshgraduate',
    component: freshgraduate
}, {
    path: '/formerstudents',
    name: 'formerstudents',
    component: formerstudents
}, {
    path: '/searchDataByStudent',
    name: 'searchDataByStudent',
    component: SearchDataByStudent
}]

const router = new VueRouter({
    routes
})



//
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {

    if (to.path === '/' || to.path === '/test' || to.path === '/register' || to.path === '/forgetPassword' || to.path === '/state' || to.path === '/selectidentity') {
        next();
    } else {
        // let token = sessionStorage.getItem('token');
        let baseInfo = sessionStorage.getItem("ID");
        // console.log("导航守卫", baseInfo);

        // if (token === 'null' || token === '') {
        if (baseInfo === 'null' || baseInfo === '' || baseInfo == null) {
            next('/');
        } else {
            next();
        }
    }
});

//重复路由
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router